import { Grid, makeStyles } from '@material-ui/core';
import { Button, StandardDialog, TextField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useTaxCertificateStore } from '../hooks/useTaxCertificateStore';
import { SearchBar } from 'libs/feature-special-servicing/src/specialServicing/components/loan/loanSearchBar';
import { LoanCard } from 'libs/feature-special-servicing/src/specialServicing/components/card/loanCard';

interface IOrderTaxCertificateModalProps {
  showOrderCertificateModal: boolean;
  closeOrderModal: () => void;
}

export const OrderTaxCertificateModal = observer(({ showOrderCertificateModal, closeOrderModal }: IOrderTaxCertificateModalProps) => {
  const { taxCertificateStore } = useTaxCertificateStore();
  const { loan } = taxCertificateStore;

  const getContent = () => {
    return (
      <Grid container>
        <Grid item xs={12}>
          <SearchBar store={taxCertificateStore} />
        </Grid>
        {loan?.loanId && (
          <Grid style={{ marginTop: '10px' }} item xs={12}>
            <LoanCard
              loan={loan}
              title={`Loan Information`}
            />

          </Grid>
        )}
      </Grid>
    );
  }

  return (
    <StandardDialog
      open={showOrderCertificateModal}
      title={"Order Certificate"}
      maxWidth="sm"
      handleClose={closeOrderModal}
      dialogContent={
        getContent()
      }
      dialogActions={(
        <>
          <Button
            style={{ marginRight: '8px' }}
            onClick={() => {
              closeOrderModal();
              taxCertificateStore.setLoan({});
            }}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              taxCertificateStore.createTaxCertificate();
              taxCertificateStore.setLoan({});
              closeOrderModal();
            }}
            color="primary"
            variant="contained"
            testId="confirm"
            disabled={!loan?.loanId}
          >
            Order
          </Button>
        </>
      )}
    />
  );

});
